const SIZE_CHART_CUSTOM_INJECTED_JAVASCRIPT = `
const mainContent = document.querySelector('body');
const bodyContent = document.body.innerHTML.trim();
window?.ReactNativeWebView?.postMessage(JSON.stringify({showPlaceholder: !bodyContent}));
`;

export default SIZE_CHART_CUSTOM_INJECTED_JAVASCRIPT;
